import React from "react";
import RevertControl from "./editor/RevertControl";
import { DOC_STATUS_OPTIONS } from "../../utils/docStatus";

const RecordDetailActions = ({
  canEdit,
  detailModel,
  hasEditAudit,
  loading,
  isSaving,
  isReverting,
  saveLabel,
  isEditing,
  startEditing,
  cancelEditing,
  save,
  revertError,
  onRevert,
  isOriginalView,
  onViewOriginal,
  onViewCurrent,
  onDownload,
  showDownload,
  downloadDisabled,
  downloadLabel,
  onClose,
  showDocStatusControl = false,
  docStatus = "",
  onDocStatusChange,
}) => (
  <div className="relative px-6 py-5">
    <div className="flex flex-wrap items-center justify-end gap-2">

            {canEdit && detailModel ? (
              isEditing ? (
                       <>
               {showDocStatusControl ? (
              <label className="flex items-center gap-2 rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-xs font-semibold text-slate-300">
                <span>Status</span>
                <select
                  value={docStatus}
                  onChange={(event) => onDocStatusChange?.(event.target.value)}
                  className="min-h-[1.75rem] bg-transparent text-xs font-semibold text-slate-100 outline-none"
                  aria-label="Document status"
                >
                  {DOC_STATUS_OPTIONS.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </label>
            ) : null}
            {!isOriginalView && hasEditAudit && onViewOriginal ? (
              <button
                type="button"
                onClick={onViewOriginal}
                disabled={loading}
                className="rounded-lg border border-amber-500/40 bg-amber-500/10 px-3 py-2 text-xs font-semibold text-amber-100 transition-colors hover:border-amber-400 hover:text-white disabled:cursor-not-allowed disabled:opacity-40"
              >
                View original document
              </button>
            ) : null}

            <RevertControl
              show={Boolean(hasEditAudit && onRevert)}
              loading={loading}
              isSaving={isSaving}
              isReverting={isReverting}
              revertError={revertError}
              onRevert={onRevert}
            />
            <button
              type="button"
              onClick={save}
              disabled={isSaving}
              className="rounded-lg border border-sky-500/40 bg-sky-500/10 px-3 py-2 text-xs font-semibold text-sky-100 transition-colors hover:border-sky-400 hover:text-white disabled:cursor-not-allowed disabled:opacity-40"
            >
              {isSaving ? "Saving..." : saveLabel}
            </button>
            <button
              type="button"
              onClick={cancelEditing}
              disabled={isSaving}
              className="rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-xs font-semibold text-slate-200 transition-colors hover:border-slate-500 hover:text-white disabled:cursor-not-allowed disabled:opacity-40"
            >
              Cancel
            </button>
          </>
        ) : (
          <button
            type="button"
            onClick={startEditing}
            disabled={loading}
            className="rounded-lg border border-sky-500/40 bg-sky-500/10 px-3 py-2 text-xs font-semibold text-sky-100 transition-colors hover:border-sky-400 hover:text-white disabled:cursor-not-allowed disabled:opacity-40"
          >
            Edit Record
          </button>
        )
      ) : null}
      {isOriginalView && onViewCurrent ? (
        <button
          type="button"
          onClick={onViewCurrent}
          disabled={loading}
          className="rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-xs font-semibold text-slate-200 transition-colors hover:border-slate-500 hover:text-white disabled:cursor-not-allowed disabled:opacity-40"
        >
          View current document
        </button>
      ) : null}
      {!isOriginalView && hasEditAudit && onViewOriginal && !isEditing? (
        <button
          type="button"
          onClick={onViewOriginal}
          disabled={loading}
          className="rounded-lg border border-amber-500/40 bg-amber-500/10 px-3 py-2 text-xs font-semibold text-amber-100 transition-colors hover:border-amber-400 hover:text-white disabled:cursor-not-allowed disabled:opacity-40"
        >
          View original document
        </button>
      ) : null}

      {!isEditing ? (
        <RevertControl
          show={Boolean(hasEditAudit && onRevert)}
          loading={loading}
          isSaving={isSaving}
          isReverting={isReverting}
          revertError={revertError}
          onRevert={onRevert}
        />
      ) : null}
      {showDownload && !isEditing ? (
        <>
        <button
          type="button"
          onClick={onDownload}
          disabled={downloadDisabled || isEditing}
          className="rounded-lg border border-emerald-500/40 bg-emerald-500/10 px-3 py-2 text-xs font-semibold text-emerald-200 transition-colors hover:border-emerald-400 hover:text-emerald-100 disabled:cursor-not-allowed disabled:opacity-40"
        >
          {downloadLabel}
        </button>

           
      
      <button
        type="button"
        onClick={onClose}
        className="rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-xs font-semibold text-slate-200 transition-colors hover:border-slate-500 hover:text-white"
      >
        Close
      </button>
      </>
      ) : null}
    </div>
  </div>
);

export default RecordDetailActions;
